<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: 'cv-04',
          word:
            '好，此乃千秋亭，在澄瑞亭的南边，和万春亭相对称。万春亭代表春天，千秋亭代表秋天。',
          audio: 'ytx',
          scene: 'scene7',
        },
        {
          headImg: 'cv-04',
          word:
            '亭子是明嘉靖十五年建的，和万春亭从外形到设计都差不多，最大的区别就是这两个亭子的藻井。',
          audio: 'ytx',
          scene: 'scene7_1',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/ytx/06');
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/千秋亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
